module.exports = __webpack_public_path__ + "static/profile-pic-ff816b76ca9f5d18a8591d072e8cb1c1.jpg";